import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string()
    .required("Please fill out this field.")
    .max(100, "Asset name must be at most 100 characters."),
  type: Yup.string().required("Please choose an option."),
  description: Yup.string().max(500, "Description must be at most 500 characters."),
  managerId: Yup.string().required("Please choose an option."),
  images: Yup.array(),
});
